import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { FileDropZone } from 'cat-ecommerce-alloy';
import useFileUploader from './hooks/useFileUploader';
import styles from './styles.module.scss';
import { DEFAULT_ROW_VALUES } from '../constants';

const ShoppingCartDropZone = ({
  children,
  errorInfo,
  shoppingCartMaxItems
}) => {
  const [t] = useTranslation();
  const { setFieldValue, setStatus, values } = useFormikContext();
  const { handleFileUpload } = useFileUploader({
    defaultRowValues: DEFAULT_ROW_VALUES,
    errorInfo,
    setFieldValue,
    setStatus,
    shoppingCartMaxItems,
    values
  });

  return (
    <FileDropZone
      message={
        <div className={cx('pt-3', styles['drop-zone-message-container'])}>
          <p className="text-center text-xxl u-color--DarkGray text-univers--bold">
            {t('DRAG_DROP_UPLOAD').toUpperCase()}
          </p>
        </div>
      }
      onFileDrop={handleFileUpload}
      iconClassname={styles['drop-zone-icon']}
    >
      <div className={cx(styles['drop-zone_content'], 'pb-md-3 px-xl-5')}>
        {children}
      </div>
    </FileDropZone>
  );
};

ShoppingCartDropZone.propTypes = {
  children: PropTypes.node,
  errorInfo: PropTypes.shape({
    domain: PropTypes.string,
    message: PropTypes.string,
    path: PropTypes.string
  }),
  shoppingCartMaxItems: PropTypes.number
};

export default ShoppingCartDropZone;
